export default __webpack_public_path__ + "static/media/42t.147f0aed.jpg";